import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { clientAccountInitialValues } from 'components/organisms/forms/client-account/ClientAccountForm';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiNavigationArrow, PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteClientAccount,
  useGetClientAccount,
} from 'services/client-account';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const ClientAccount = () => {
  const accountId = useParamId('client-account');
  const account = useGetClientAccount(accountId);
  const navigate = useNavigate();
  const i18nextPrefix = 'user';
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const navigateToNewWindow = useNewWindowNavigate();

  const deleteAccount = useDeleteClientAccount();

  const onRemoveAccount = async (actions: PopupActions) => {
    await deleteAccount.mutateAsync(accountId, {
      onError: (error: Error) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => {
        navigate('/client-account');
      },
    });
  };

  return (
    <Form.ClientAccount
      i18nextPrefix={i18nextPrefix}
      tittle={account.data?.name ?? '-'}
      initialValues={
        account.data
          ? middleware.clientAccount.queryToForm(account.data)
          : clientAccountInitialValues
      }
      backPath='client-account'
      onSubmit={() => {}}
      status={{ displayMode: true, isLoading: account.isLoading }}
      topbarContent={
        <div className='flex  justify-end gap-2'>
          {!!account.data?.label && (
            <Button
              type='button'
              isClear
              onlyIcon
              onClick={() =>
                navigateToNewWindow(`label/${account.data?.label?.id}/finances`)
              }>
              <Button.Icon
                icon={<PiNavigationArrow transform='scale(-1,1)' />}
              />
            </Button>
          )}
          <Button
            isClear
            onlyIcon
            onClick={() => {
              navigate(
                `/client-account/edit/${accountId}/${getLastPathname(
                  pathname
                )}`,
                {
                  replace: true,
                }
              );
            }}>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            name={account.data?.name}
            onRemove={onRemoveAccount}
          />
        </div>
      }
    />
  );
};

export default ClientAccount;
